import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BeaconState {
    isHidden: boolean;
}

const initialState: BeaconState = {
    isHidden: false,
};

const beaconSlice = createSlice({
    name: "beacon",
    initialState,
    reducers: {
        setBeaconVisibility: (state, action: PayloadAction<boolean>) => {
            state.isHidden = action.payload;
        },
        hideBeacon: (state) => {
            state.isHidden = true;
        },
        showBeacon: (state) => {
            state.isHidden = false;
        },
    },
});

export const { setBeaconVisibility, hideBeacon, showBeacon } = beaconSlice.actions;
export default beaconSlice.reducer;
